import { FirebaseAuth } from "../components/FirebaseAuth/firebase";
import { getClientMetadata } from "./audit";

const ACTIVITY_EVENTS = new Map([
  ["signed in", "signed_in"],
  ["signed_in", "signed_in"],
  ["signed out", "signed_out"],
  ["signed_out", "signed_out"],
  ["mfa verified", "mfa_verified"],
  ["mfa_verified", "mfa_verified"],
  ["mfa device removed", "mfa_device_removed"],
  ["mfa_device_removed", "mfa_device_removed"],
  ["mfa disabled", "mfa_disabled"],
  ["mfa_disabled", "mfa_disabled"],
  ["mfa enrolled", "mfa_enrolled"],
  ["mfa_enrolled", "mfa_enrolled"],
  ["user name updated", "user_name_updated"],
  ["user_name_updated", "user_name_updated"],
  ["phone number updated", "phone_number_updated"],
  ["phone_number_updated", "phone_number_updated"],
  ["business type updated", "business_type_updated"],
  ["business_type_updated", "business_type_updated"],
  ["email address updated", "email_address_updated"],
  ["email_address_updated", "email_address_updated"],
  ["password updated", "password_updated"],
  ["password_updated", "password_updated"],
  ["profile photo updated", "profile_photo_updated"],
  ["profile_photo_updated", "profile_photo_updated"],
  ["resume uploaded", "resume_uploaded"],
  ["resume_uploaded", "resume_uploaded"],
  ["profile regenerated", "profile_regenerated"],
  ["profile_regenerated", "profile_regenerated"],
  ["pricing update requested", "pricing_update_requested"],
  ["pricing_update_requested", "pricing_update_requested"],
  ["phone verified", "phone_verified"],
  ["phone_verified", "phone_verified"],
  ["identity verified", "identity_verified"],
  ["identity_verified", "identity_verified"],
  ["document submitted", "document_submitted"],
  ["document_submitted", "document_submitted"],
]);

const normalizeActivityEvent = (action) => {
  const value = String(action || "").trim().toLowerCase();
  return ACTIVITY_EVENTS.get(value) || "";
};

export const recordUserActivity = async (action, description = "") => {
  const currentUser = FirebaseAuth.auth().currentUser;
  if (!currentUser) return false;

  const event = normalizeActivityEvent(action);
  if (!event) return false;

  try {
    const metadata = await getClientMetadata();
    const createUserActivityLog = FirebaseAuth.functions().httpsCallable("createUserActivityLog");
    await createUserActivityLog({
      action: event,
      description: description || metadata.user_agent || "",
      ip: metadata.ip || "",
      location: metadata.location || "",
      user_agent: metadata.user_agent || navigator.userAgent || "",
    });
    return true;
  } catch (_error) {
    return false;
  }
};
